export enum Country {
  Afeganistao = 'AFEGANISTAO',
  AlandIlhas = 'ALAND_ILHAS',
  Albania = 'ALBANIA_REPUBLICA',
  Alemanha = 'ALEMANHA',
  BurkinaFaso = 'BURKINA_FASO',
  Andorra = 'ANDORRA',
  Angola = 'ANGOLA',
  Anguilla = 'ANGUILLA',
  Antartica = 'ANTARTICA',
  AntiguaEBarbuda = 'ANTIGUA_E_BARBUDA',
  AntilhasHolandesas = 'ANTILHAS_HOLANDESAS',
  ArabiaSaudita = 'ARABIA_SAUDITA',
  Argelia = 'ARGELIA',
  Argentina = 'ARGENTINA',
  Armenia = 'ARMENIA_REPUBLICA',
  Aruba = 'ARUBA',
  Australia = 'AUSTRALIA',
  Austria = 'AUSTRIA',
  Azerbaijao = 'AZERBAIJAO_REPUBLICA',
  BahamasIlhas = 'BAHAMAS_ILHAS',
  BahreinIlhas = 'BAHREIN_ILHAS',
  Bangladesh = 'BANGLADESH',
  Barbados = 'BARBADOS',
  Belarus = 'BELARUS_REPUBLICA',
  Belgica = 'BELGICA',
  Belize = 'BELIZE',
  Bermudas = 'BERMUDAS',
  MianmarBirmania = 'MIANMAR_BIRMANIA',
  Bolivia = 'BOLIVIA_ESTADO_PLURINACIONAL',
  BosniaHerzegovina = 'BOSNIA_HERZEGOVINA_REPUBLICA',
  Bonaire = 'BONAIRE',
  Botsuana = 'BOTSUANA',
  BouvetIlha = 'BOUVET_ILHA',
  Brasil = 'BRASIL',
  Brunei = 'BRUNEI',
  Bulgaria = 'BULGARIA_REPUBLICA',
  Burundi = 'BURUNDI',
  Butao = 'BUTAO',
  CaboVerde = 'CABO_VERDE_REPUBLICA',
  CaymanIlhas = 'CAYMAN_ILHAS',
  Camboja = 'CAMBOJA',
  Camaroes = 'CAMAROES',
  Canada = 'CANADA',
  CanariasIlhas = 'CANARIAS_ILHAS',
  Cazaquistao = 'CAZAQUISTAO_REPUBLICA',
  Catar = 'CATAR',
  Chile = 'CHILE',
  China = 'CHINA_REPUBLICA_POPULAR',
  FormosaTaiwan = 'FORMOSA_TAIWAN',
  Chipre = 'CHIPRE',
  CocosKeelingIlhas = 'COCOS_KEELING_ILHAS',
  Colombia = 'COLOMBIA',
  ComoresIlhas = 'COMORES_ILHAS',
  Congo = 'CONGO',
  CookIlhas = 'COOK_ILHAS',
  CoreiaNorte = 'COREIA_DO_NORTE_REPUBLICA',
  CoreiaSul = 'COREIA_DO_SUL_REPUBLICA',
  CostaDoMarfim = 'COSTA_DO_MARFIM',
  Croacia = 'CROACIA_REPUBLICA',
  CostaRica = 'COSTA_RICA',
  Kuwait = 'KUWAIT',
  Cuba = 'CUBA',
  Curacao = 'CURACAO',
  Benin = 'BENIN',
  Dinamarca = 'DINAMARCA',
  DominicaIlha = 'DOMINICA_ILHA',
  Equador = 'EQUADOR',
  Egito = 'EGITO',
  Eritreia = 'ERITREIA',
  EmiradosArabesUnidos = 'EMIRADOS_ARABES_UNIDOS',
  Espanha = 'ESPANHA',
  Eslovenia = 'ESLOVENIA_REPUBLICA',
  Eslovaca = 'ESLOVACA_REPUBLICA',
  EstadosUnidos = 'ESTADOS_UNIDOS',
  Estonia = 'ESTONIA_REPUBLICA',
  Etiopia = 'ETIOPIA',
  FalklandIlhasMalvinas = 'FALKLAND_ILHAS_MALVINAS',
  FeroeIlhas = 'FEROE_ILHAS',
  Filipinas = 'FILIPINAS',
  Finlandia = 'FINLANDIA',
  Franca = 'FRANCA',
  Gabao = 'GABAO',
  Gambia = 'GAMBIA',
  Gana = 'GANA',
  Georgia = 'GEORGIA_REPUBLICA',
  GeorgiaDoSulESandwichDoSulIlhas = 'ILHAS_GEORGIA_SANDWICH_DO_SUL',
  Gibraltar = 'GIBRALTAR',
  Granada = 'GRANADA',
  Grecia = 'GRECIA',
  Groenlandia = 'GROENLANDIA',
  Guadalupe = 'GUADALUPE',
  Guam = 'GUAM',
  Guatemala = 'GUATEMALA',
  GuernseyIlhaDoCanal = 'GUERNSEY_ILHA_DO_CANAL',
  GuianaFrancesa = 'GUIANA_FRANCESA',
  Guine = 'GUINE',
  GuineEquatorial = 'GUINE_EQUATORIAL',
  GuineBissau = 'GUINE_BISSAU',
  Guiana = 'GUIANA',
  Haiti = 'HAITI',
  IlhaHeardEIlhasMcdonald = 'ILHA_HEARD_E_ILHAS_MCDONALD',
  Honduras = 'HONDURAS',
  HongKong = 'HONG_KONG',
  Hungria = 'HUNGRIA_REPUBLICA',
  Iemen = 'IEMEN',
  IlhaDeMan = 'MAN_ILHA',
  India = 'INDIA',
  Indonesia = 'INDONESIA',
  Iraque = 'IRAQUE',
  Ira = 'IRA_REPUBLICA_ISLAMICA',
  Irlanda = 'IRLANDA',
  Islandia = 'ISLANDIA',
  Israel = 'ISRAEL',
  Italia = 'ITALIA',
  Jamaica = 'JAMAICA',
  JerseyIlhaDoCanal = 'JERSEY_ILHA_DO_CANAL',
  JohnstonIlhas = 'JOHNSTON_ILHAS',
  Japao = 'JAPAO',
  Jordania = 'JORDANIA',
  Kiribati = 'KIRIBATI',
  Laos = 'LAOS_REP_POP_DEMOCR',
  LebuanIlhas = 'LEBUAN_ILHAS',
  Lesoto = 'LESOTO',
  Letonia = 'LETONIA_REPUBLICA',
  Libano = 'LIBANO',
  Liberia = 'LIBERIA',
  Libia = 'LIBIA',
  Liechtenstein = 'LIECHTENSTEIN',
  Lituania = 'LITUANIA_REPUBLICA',
  Luxemburgo = 'LUXEMBURGO',
  Macau = 'MACAU',
  MacedoniaDoNorte = 'MACEDONIA_DO_NORTE',
  Madagascar = 'MADAGASCAR',
  MadeiraIlha = 'MADEIRA_ILHA',
  Malasia = 'MALASIA',
  Malavi = 'MALAVI',
  Maldivas = 'MALDIVAS',
  Mali = 'MALI',
  Malta = 'MALTA',
  MarianasDoNorte = 'MARIANAS_DO_NORTE',
  Marrocos = 'MARROCOS',
  MarshallIlhas = 'MARSHALL_ILHAS',
  Martinica = 'MARTINICA',
  Mauricio = 'MAURICIO',
  Mauritania = 'MAURITANIA',
  MayotteIlhasFrancesas = 'MAYOTTE_ILHAS_FRANCESAS',
  MidwayIlhas = 'MIDWAY_ILHAS',
  Mexico = 'MEXICO',
  Moldavia = 'MOLDAVIA_REPUBLICA',
  Monaco = 'MONACO',
  Mongolia = 'MONGOLIA',
  Montenegro = 'MONTENEGRO',
  Micronesia = 'MICRONESIA',
  MontserratIlhas = 'MONTSERRAT_ILHAS',
  Mocambique = 'MOCAMBIQUE',
  Namibia = 'NAMIBIA',
  Nauru = 'NAURU',
  ChristmasIlhaNavidad = 'CHRISTMAS_ILHA_NAVIDAD',
  Nepal = 'NEPAL',
  Nicaragua = 'NICARAGUA',
  Niger = 'NIGER',
  Nigeria = 'NIGERIA',
  NiueIlha = 'NIUE_ILHA',
  NorfolkIlha = 'NORFOLK_ILHA',
  Noruega = 'NORUEGA',
  NovaCaledonia = 'NOVA_CALEDONIA',
  PapuaNovaGuine = 'PAPUA_NOVA_GUINE',
  NovaZelandia = 'NOVA_ZELANDIA',
  Vanuatu = 'VANUATU',
  Oma = 'OMA',
  PacificoIlhas = 'PACIFICO_ILHAS',
  PaisesBaixos = 'PAISES_BAIXOS_HOLANDA',
  Palau = 'PALAU',
  Paquistao = 'PAQUISTAO',
  Palestina = 'PALESTINA',
  Panama = 'PANAMA',
  Paraguai = 'PARAGUAI',
  Peru = 'PERU',
  PitcairnIlha = 'PITCAIRN_ILHA',
  PolinesiaFrancesa = 'POLINESIA_FRANCESA',
  Polonia = 'POLONIA_REPUBLICA',
  Portugal = 'PORTUGAL',
  PortoRico = 'PORTO_RICO',
  Quenia = 'QUENIA',
  Quirguiz = 'QUIRGUIZ_REPUBLICA',
  ReinoUnido = 'REINO_UNIDO',
  RepublicaCentroAfricana = 'REPUBLICA_CENTRO_AFRICANA',
  RepublicaDominicana = 'REPUBLICA_DOMINICANA',
  ReuniaoIlha = 'REUNIAO_ILHA',
  Zimbabue = 'ZIMBABUE',
  Romenia = 'ROMENIA',
  Ruanda = 'RUANDA',
  Russia = 'RUSSIA_FEDERACAO',
  SalomaoIlhas = 'SALOMAO_ILHAS',
  SaaraOcidental = 'SAARA_OCIDENTAL',
  ElSalvador = 'EL_SALVADOR',
  Samoa = 'SAMOA',
  SamoaAmericana = 'SAMOA_AMERICANA',
  SaoCristovaoENevesIlhas = 'SAO_CRISTOVAO_E_NEVES_ILHAS',
  SaoBartolomeu = 'SAO_BARTOLOMEU',
  SanMarino = 'SAN_MARINO',
  SaoMartinhoFrances = 'SAO_MARTINHO_ILHA_DE_PARTE_FRANCESA',
  SaoMartinhoHolandes = 'SAO_MARTINHO_ILHA_DE_PARTE_HOLANDESA',
  SaoPedroEMiquelon = 'SAO_PEDRO_E_MIQUELON',
  SaoVicenteEGranadinas = 'SAO_VICENTE_E_GRANADINAS',
  SantaHelena = 'SANTA_HELENA',
  SantaLucia = 'SANTA_LUCIA',
  SaoTomeEPrincipeIlhas = 'SAO_TOME_E_PRINCIPE_ILHAS',
  Senegal = 'SENEGAL',
  Seychelles = 'SEYCHELLES',
  SerraLeoa = 'SERRA_LEOA',
  Servia = 'SERVIA',
  Cingapura = 'CINGAPURA',
  Siria = 'SIRIA_REPUBLICA_ARABE',
  Somalia = 'SOMALIA',
  SriLanka = 'SRI_LANKA',
  Essuatini = 'ESSUATINI',
  SvalbardEJanMayern = 'SVALBARD_E_JAN_MAYERN',
  AfricaDoSul = 'AFRICA_DO_SUL',
  Sudao = 'SUDAO',
  SudaoDoSul = 'SUDAO_DO_SUL',
  Suecia = 'SUECIA',
  Suica = 'SUICA',
  Suriname = 'SURINAME',
  Tadjiquistao = 'TADJIQUISTAO_REPUBLICA',
  Tailandia = 'TAILANDIA',
  Tanzania = 'TANZANIA_REP_UNIDA',
  TerrasAustraisEAntarticasFrancesas = 'TERRAS_AUSTRAIS_E_ANTARTICAS_FRANCESAS',
  TerritorioBritOcIndico = 'TERRITORIO_BRIT_OC_INDICO',
  Djibuti = 'DJIBUTI',
  Chade = 'CHADE',
  Tcheca = 'TCHECA_REPUBLICA',
  TimorLeste = 'TIMOR_LESTE',
  Togo = 'TOGO',
  ToquelauIlhas = 'TOQUELAU_ILHAS',
  Tonga = 'TONGA',
  TrinidadETobago = 'TRINIDAD_E_TOBAGO',
  Tunisia = 'TUNISIA',
  TurcasECaicosIlhas = 'TURCAS_E_CAICOS_ILHAS',
  Turcomenistao = 'TURCOMENISTAO_REPUBLICA',
  Turquia = 'TURQUIA',
  Tuvalu = 'TUVALU',
  Ucrania = 'UCRANIA',
  Uganda = 'UGANDA',
  Uruguai = 'URUGUAI',
  Uzbequistao = 'UZBEQUISTAO_REPUBLICA',
  Vaticano = 'VATICANO_EST_DA_CIDADE',
  Venezuela = 'VENEZUELA',
  Vietna = 'VIETNA',
  VirgensBritanicas = 'VIRGENS_ILHAS_BRITANICAS',
  VirgensEUA = 'VIRGENS_ILHAS_E_U_A',
  Fiji = 'FIJI',
  WallisEFutunaIlhas = 'WALLIS_E_FUTUNA_ILHAS',
  WakeIlha = 'WAKE_ILHA',
  CongoDemocratico = 'CONGO_REPUBLICA_DEMOCRATICA',
  Zambia = 'ZAMBIA',
}

export const CountryLabels: Record<Country, string> = {
  [Country.Afeganistao]: 'Afeganistao',
  [Country.AlandIlhas]: 'Aland Ilhas',
  [Country.Albania]: 'Albania',
  [Country.Alemanha]: 'Alemanha',
  [Country.BurkinaFaso]: 'Burkina Faso',
  [Country.Andorra]: 'Andorra',
  [Country.Angola]: 'Angola',
  [Country.Anguilla]: 'Anguilla',
  [Country.Antartica]: 'Antartica',
  [Country.AntiguaEBarbuda]: 'Antigua e Barbuda',
  [Country.AntilhasHolandesas]: 'Antilhas Holandesas',
  [Country.ArabiaSaudita]: 'Arabia Saudita',
  [Country.Argelia]: 'Argelia',
  [Country.Argentina]: 'Argentina',
  [Country.Armenia]: 'Armenia',
  [Country.Aruba]: 'Aruba',
  [Country.Australia]: 'Australia',
  [Country.Austria]: 'Austria',
  [Country.Azerbaijao]: 'Azerbaijao',
  [Country.BahamasIlhas]: 'Bahamas Ilhas',
  [Country.BahreinIlhas]: 'Bahrein Ilhas',
  [Country.Bangladesh]: 'Bangladesh',
  [Country.Barbados]: 'Barbados',
  [Country.Belarus]: 'Belarus',
  [Country.Belgica]: 'Belgica',
  [Country.Belize]: 'Belize',
  [Country.Bermudas]: 'Bermudas',
  [Country.MianmarBirmania]: 'Mianmar (Birmania)',
  [Country.Bolivia]: 'Bolivia',
  [Country.BosniaHerzegovina]: 'Bosnia Herzegovina',
  [Country.Bonaire]: 'Bonaire',
  [Country.Botsuana]: 'Botsuana',
  [Country.BouvetIlha]: 'Bouvet Ilha',
  [Country.Brasil]: 'Brasil',
  [Country.Brunei]: 'Brunei',
  [Country.Bulgaria]: 'Bulgaria',
  [Country.Burundi]: 'Burundi',
  [Country.Butao]: 'Butao',
  [Country.CaboVerde]: 'Cabo Verde',
  [Country.CaymanIlhas]: 'Cayman Ilhas',
  [Country.Camboja]: 'Camboja',
  [Country.Camaroes]: 'Camaroes',
  [Country.Canada]: 'Canada',
  [Country.CanariasIlhas]: 'Canarias Ilhas',
  [Country.Cazaquistao]: 'Cazaquistao',
  [Country.Catar]: 'Catar',
  [Country.Chile]: 'Chile',
  [Country.China]: 'China',
  [Country.FormosaTaiwan]: 'Formosa (Taiwan)',
  [Country.Chipre]: 'Chipre',
  [Country.CocosKeelingIlhas]: 'Cocos (Keeling) Ilhas',
  [Country.Colombia]: 'Colombia',
  [Country.ComoresIlhas]: 'Comores Ilhas',
  [Country.Congo]: 'Congo',
  [Country.CookIlhas]: 'Cook Ilhas',
  [Country.CoreiaNorte]: 'Coreia do Norte',
  [Country.CoreiaSul]: 'Coreia do Sul',
  [Country.CostaDoMarfim]: 'Costa do Marfim',
  [Country.Croacia]: 'Croacia',
  [Country.CostaRica]: 'Costa Rica',
  [Country.Kuwait]: 'Kuwait',
  [Country.Cuba]: 'Cuba',
  [Country.Curacao]: 'Curacao',
  [Country.Benin]: 'Benin',
  [Country.Dinamarca]: 'Dinamarca',
  [Country.DominicaIlha]: 'Dominica Ilha',
  [Country.Equador]: 'Equador',
  [Country.Egito]: 'Egito',
  [Country.Eritreia]: 'Eritreia',
  [Country.EmiradosArabesUnidos]: 'Emirados Arabes Unidos',
  [Country.Espanha]: 'Espanha',
  [Country.Eslovenia]: 'Eslovenia',
  [Country.Eslovaca]: 'Eslovaca',
  [Country.EstadosUnidos]: 'Estados Unidos',
  [Country.Estonia]: 'Estonia',
  [Country.Etiopia]: 'Etiopia',
  [Country.FalklandIlhasMalvinas]: 'Falkland (Malvinas)',
  [Country.FeroeIlhas]: 'Feroe Ilhas',
  [Country.Filipinas]: 'Filipinas',
  [Country.Finlandia]: 'Finlandia',
  [Country.Franca]: 'Franca',
  [Country.Gabao]: 'Gabao',
  [Country.Gambia]: 'Gambia',
  [Country.Gana]: 'Gana',
  [Country.Georgia]: 'Georgia',
  [Country.GeorgiaDoSulESandwichDoSulIlhas]:
    'Georgia do Sul e Sandwich do Sul Ilhas',
  [Country.Gibraltar]: 'Gibraltar',
  [Country.Granada]: 'Granada',
  [Country.Grecia]: 'Grecia',
  [Country.Groenlandia]: 'Groenlandia',
  [Country.Guadalupe]: 'Guadalupe',
  [Country.Guam]: 'Guam',
  [Country.Guatemala]: 'Guatemala',
  [Country.GuernseyIlhaDoCanal]: 'Guernsey Ilha do Canal',
  [Country.GuianaFrancesa]: 'Guiana Francesa',
  [Country.Guine]: 'Guine',
  [Country.GuineEquatorial]: 'Guine Equatorial',
  [Country.GuineBissau]: 'Guine-Bissau',
  [Country.Guiana]: 'Guiana',
  [Country.Haiti]: 'Haiti',
  [Country.IlhaHeardEIlhasMcdonald]: 'Ilha Heard e Ilhas Mcdonald',
  [Country.Honduras]: 'Honduras',
  [Country.HongKong]: 'Hong Kong',
  [Country.Hungria]: 'Hungria',
  [Country.Iemen]: 'Iemen',
  [Country.IlhaDeMan]: 'Ilha de Man',
  [Country.India]: 'India',
  [Country.Indonesia]: 'Indonesia',
  [Country.Iraque]: 'Iraque',
  [Country.Ira]: 'Ira',
  [Country.Irlanda]: 'Irlanda',
  [Country.Islandia]: 'Islandia',
  [Country.Israel]: 'Israel',
  [Country.Italia]: 'Italia',
  [Country.Jamaica]: 'Jamaica',
  [Country.JerseyIlhaDoCanal]: 'Jersey Ilha do Canal',
  [Country.JohnstonIlhas]: 'Johnston Ilhas',
  [Country.Japao]: 'Japao',
  [Country.Jordania]: 'Jordania',
  [Country.Kiribati]: 'Kiribati',
  [Country.Laos]: 'Laos',
  [Country.LebuanIlhas]: 'Lebuan Ilhas',
  [Country.Lesoto]: 'Lesoto',
  [Country.Letonia]: 'Letonia',
  [Country.Libano]: 'Libano',
  [Country.Liberia]: 'Liberia',
  [Country.Libia]: 'Libia',
  [Country.Liechtenstein]: 'Liechtenstein',
  [Country.Lituania]: 'Lituania',
  [Country.Luxemburgo]: 'Luxemburgo',
  [Country.Macau]: 'Macau',
  [Country.MacedoniaDoNorte]: 'Macedonia do Norte',
  [Country.Madagascar]: 'Madagascar',
  [Country.MadeiraIlha]: 'Madeira Ilha',
  [Country.Malasia]: 'Malasia',
  [Country.Malavi]: 'Malavi',
  [Country.Maldivas]: 'Maldivas',
  [Country.Mali]: 'Mali',
  [Country.Malta]: 'Malta',
  [Country.MarianasDoNorte]: 'Marianas do Norte',
  [Country.Marrocos]: 'Marrocos',
  [Country.MarshallIlhas]: 'Marshall Ilhas',
  [Country.Martinica]: 'Martinica',
  [Country.Mauricio]: 'Mauricio',
  [Country.Mauritania]: 'Mauritania',
  [Country.MayotteIlhasFrancesas]: 'Mayotte (Francesas)',
  [Country.MidwayIlhas]: 'Midway Ilhas',
  [Country.Mexico]: 'Mexico',
  [Country.Moldavia]: 'Moldavia',
  [Country.Monaco]: 'Monaco',
  [Country.Mongolia]: 'Mongolia',
  [Country.Montenegro]: 'Montenegro',
  [Country.Micronesia]: 'Micronesia',
  [Country.MontserratIlhas]: 'Montserrat Ilhas',
  [Country.Mocambique]: 'Mocambique',
  [Country.Namibia]: 'Namibia',
  [Country.Nauru]: 'Nauru',
  [Country.ChristmasIlhaNavidad]: 'Christmas (Navidad)',
  [Country.Nepal]: 'Nepal',
  [Country.Nicaragua]: 'Nicaragua',
  [Country.Niger]: 'Niger',
  [Country.Nigeria]: 'Nigeria',
  [Country.NiueIlha]: 'Niue Ilha',
  [Country.NorfolkIlha]: 'Norfolk Ilha',
  [Country.Noruega]: 'Noruega',
  [Country.NovaCaledonia]: 'Nova Caledonia',
  [Country.PapuaNovaGuine]: 'Papua Nova Guine',
  [Country.NovaZelandia]: 'Nova Zelandia',
  [Country.Vanuatu]: 'Vanuatu',
  [Country.Oma]: 'Oma',
  [Country.PacificoIlhas]: 'Pacifico Ilhas',
  [Country.PaisesBaixos]: 'Paises Baixos',
  [Country.Palau]: 'Palau',
  [Country.Paquistao]: 'Paquistao',
  [Country.Palestina]: 'Palestina',
  [Country.Panama]: 'Panama',
  [Country.Paraguai]: 'Paraguai',
  [Country.Peru]: 'Peru',
  [Country.PitcairnIlha]: 'Pitcairn Ilha',
  [Country.PolinesiaFrancesa]: 'Polinesia Francesa',
  [Country.Polonia]: 'Polonia',
  [Country.Portugal]: 'Portugal',
  [Country.PortoRico]: 'Porto Rico',
  [Country.Quenia]: 'Quenia',
  [Country.Quirguiz]: 'Quirguiz',
  [Country.ReinoUnido]: 'Reino Unido',
  [Country.RepublicaCentroAfricana]: 'Republica Centro-Africana',
  [Country.RepublicaDominicana]: 'Republica Dominicana',
  [Country.ReuniaoIlha]: 'Reuniao Ilha',
  [Country.Zimbabue]: 'Zimbabue',
  [Country.Romenia]: 'Romenia',
  [Country.Ruanda]: 'Ruanda',
  [Country.Russia]: 'Russia',
  [Country.SalomaoIlhas]: 'Salomao Ilhas',
  [Country.SaaraOcidental]: 'Saara Ocidental',
  [Country.ElSalvador]: 'El Salvador',
  [Country.Samoa]: 'Samoa',
  [Country.SamoaAmericana]: 'Samoa Americana',
  [Country.SaoCristovaoENevesIlhas]: 'Sao Cristovao e Neves',
  [Country.SaoBartolomeu]: 'Sao Bartolomeu',
  [Country.SanMarino]: 'San Marino',
  [Country.SaoMartinhoFrances]: 'Sao Martinho (Frances)',
  [Country.SaoMartinhoHolandes]: 'Sao Martinho (Holandes)',
  [Country.SaoPedroEMiquelon]: 'Sao Pedro e Miquelon',
  [Country.SaoVicenteEGranadinas]: 'Sao Vicente e Granadinas',
  [Country.SantaHelena]: 'Santa Helena',
  [Country.SantaLucia]: 'Santa Lucia',
  [Country.SaoTomeEPrincipeIlhas]: 'Sao Tome e Principe',
  [Country.Senegal]: 'Senegal',
  [Country.Seychelles]: 'Seychelles',
  [Country.SerraLeoa]: 'Serra Leoa',
  [Country.Servia]: 'Servia',
  [Country.Cingapura]: 'Cingapura',
  [Country.Siria]: 'Siria',
  [Country.Somalia]: 'Somalia',
  [Country.SriLanka]: 'Sri Lanka',
  [Country.Essuatini]: 'Essuatini',
  [Country.SvalbardEJanMayern]: 'Svalbard e Jan Mayen',
  [Country.AfricaDoSul]: 'Africa do Sul',
  [Country.Sudao]: 'Sudao',
  [Country.SudaoDoSul]: 'Sudao do Sul',
  [Country.Suecia]: 'Suecia',
  [Country.Suica]: 'Suica',
  [Country.Suriname]: 'Suriname',
  [Country.Tadjiquistao]: 'Tadjiquistao',
  [Country.Tailandia]: 'Tailandia',
  [Country.Tanzania]: 'Tanzania',
  [Country.TerrasAustraisEAntarticasFrancesas]:
    'Terras Austrais e Antarticas Francesas',
  [Country.TerritorioBritOcIndico]: 'Territorio Britanico do Oceano Indico',
  [Country.Djibuti]: 'Djibuti',
  [Country.Chade]: 'Chade',
  [Country.Tcheca]: 'Tcheca',
  [Country.TimorLeste]: 'Timor Leste',
  [Country.Togo]: 'Togo',
  [Country.ToquelauIlhas]: 'Toquelau Ilhas',
  [Country.Tonga]: 'Tonga',
  [Country.TrinidadETobago]: 'Trinidad e Tobago',
  [Country.Tunisia]: 'Tunisia',
  [Country.TurcasECaicosIlhas]: 'Turcas e Caicos',
  [Country.Turcomenistao]: 'Turcomenistao',
  [Country.Turquia]: 'Turquia',
  [Country.Tuvalu]: 'Tuvalu',
  [Country.Ucrania]: 'Ucrania',
  [Country.Uganda]: 'Uganda',
  [Country.Uruguai]: 'Uruguai',
  [Country.Uzbequistao]: 'Uzbequistao',
  [Country.Vaticano]: 'Vaticano',
  [Country.Venezuela]: 'Venezuela',
  [Country.Vietna]: 'Vietna',
  [Country.VirgensBritanicas]: 'Virgens Britanicas',
  [Country.VirgensEUA]: 'Virgens (EUA)',
  [Country.Fiji]: 'Fiji',
  [Country.WallisEFutunaIlhas]: 'Wallis e Futuna',
  [Country.WakeIlha]: 'Wake Ilha',
  [Country.CongoDemocratico]: 'Congo Democratico',
  [Country.Zambia]: 'Zambia',
};
